import { Link } from "react-router-dom";
import { AffiliateButton } from "./Affiliate";
import { getVpn } from "../data/vpns";
import { Reveal } from "./motion";

// Renders structured article sections: {h, p, list, p2, list2, p3, cta/ctas, link}
export const RichSections = ({ sections, numbered = true }) => (
  <div className="article-body">
    {sections.map((s, i) => (
      <Reveal key={i} className="mb-12">
        {s.h && (
          <h2 className="mb-5 flex items-baseline gap-4 font-display text-2xl font-extrabold tracking-tight text-[#0F172A] sm:text-3xl">
            {numbered && (
              <span className="font-display text-sm font-black text-[#4687FF]">
                {String(i).padStart(2, "0")}
              </span>
            )}
            {s.h}
          </h2>
        )}
        {s.p?.map((t, j) => <p key={j}>{t}</p>)}
        {s.list && <ul>{s.list.map((t, j) => <li key={j}>{t}</li>)}</ul>}
        {s.p2?.map((t, j) => <p key={j}>{t}</p>)}
        {s.list2 && <ul>{s.list2.map((t, j) => <li key={j}>{t}</li>)}</ul>}
        {s.p3?.map((t, j) => <p key={j}>{t}</p>)}
        {(s.cta || s.ctas) && (
          <div className="mt-6 flex flex-wrap gap-3">
            {(s.ctas || [s.cta]).map((c, j) => {
              const vpn = getVpn(c.vpn);
              return (
                <AffiliateButton
                  key={j}
                  href={vpn.link}
                  testId={`section-cta-${c.vpn}-${i}`}
                  variant={c.vpn === "nordvpn" ? "primary" : "dark"}
                >
                  {c.label}
                </AffiliateButton>
              );
            })}
          </div>
        )}
        {s.link && (
          <p className="mt-4">
            <Link to={s.link.to} className="font-semibold text-[#4687FF] underline underline-offset-4">
              {s.link.label} →
            </Link>
          </p>
        )}
      </Reveal>
    ))}
  </div>
);
